<template>
  <div class="el-menu-horizontal-warp layout-navbars-menu-horizontal">
    <el-scrollbar ref="scrollbarRef" @wheel="onWheelScroll">
      <el-menu
        mode="horizontal"
        router
        :ellipsis="false"
        :default-active="activePath"
        background-color="transparent"
        class="layout-navbars-menu-horizontal-el"
      >
        <template v-for="val in menuList" :key="val.path">
          <el-sub-menu v-if="val.children?.length" :index="val.path">
            <template #title>
              <span>{{ val.title }}</span>
            </template>
            <sub-item :chil="val.children" />
          </el-sub-menu>
          <el-menu-item v-else :index="val.path">
            {{ val.title }}
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import useCrmebMenuStore from '@/store/modules/menu';
import { getCrmebRouteLookupPath } from '@/utils/crmebMenu';
import SubItem from './SubItem.vue';

const route = useRoute();
const crmebMenu = useCrmebMenuStore();
const scrollbarRef = ref<{ wrapRef?: HTMLElement } | null>(null);

const menuList = computed(() => crmebMenu.columnsNavList);
const activePath = computed(() => getCrmebRouteLookupPath(route));

/** 对齐 EB horizontal.vue：滚轮横向滚动顶栏菜单 */
function onWheelScroll(e: WheelEvent) {
  const wrap = scrollbarRef.value?.wrapRef;
  if (!wrap) return;
  e.preventDefault();
  const delta = e.deltaY || e.deltaX;
  wrap.scrollLeft += delta / 4;
}

function scrollActiveIntoView() {
  nextTick(() => {
    const wrap = scrollbarRef.value?.wrapRef;
    const active = document.querySelector(
      '.layout-navbars-menu-horizontal-el.el-menu--horizontal li.is-active',
    ) as HTMLElement | null;
    if (wrap && active) {
      wrap.scrollLeft = active.offsetLeft - 80;
    }
  });
}

onMounted(scrollActiveIntoView);
watch(() => route.path, scrollActiveIntoView);
</script>

<style scoped lang="scss">
.layout-navbars-menu-horizontal {
  flex: 1;
  min-width: 0;
  height: 50px;
  overflow: hidden;
  margin-right: 8px;

  :deep(.el-scrollbar__bar.is-horizontal) {
    height: 0;
  }
  :deep(.el-scrollbar__bar.is-vertical) {
    display: none;
  }
  :deep(.el-scrollbar__wrap) {
    overflow-y: hidden !important;
  }
  :deep(.el-scrollbar__view) {
    height: 50px;
  }
  :deep(.el-menu.el-menu--horizontal) {
    display: flex;
    flex-wrap: nowrap;
    width: max-content;
    min-width: 100%;
    height: 50px;
    border-bottom: none;
  }
}
</style>
